import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { buscarUnidad } from "../api/General";
import { useCatalog } from "../context/Catalog";
import { useTramite } from "../context/Tramite";
import "./css/components.css";
import { isInvalid } from "../utils/forms";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import ArrayField from "./controls/ArrayField";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import { FuenteEfluenteLiquidoForm } from "./FuenteEfluenteLiquidoForm";
import { FuenteEfluenteLiquidoList } from "./FuenteEfluenteLiquidoList";

function crearFuenteEfluente(fuentesEfluentesLiquidos) {
  const orden =
    Math.max(
      0,
      ...fuentesEfluentesLiquidos?.map(
        (fuenteEfluenteLiquidos) => fuenteEfluenteLiquidos.orden,
      ),
    ) + 1;
  return {
    orden,
    nombre: "",
    operacionesUnitarias: [],
    caudalMedio: { magnitud: 0, unidad: undefined },
    destino: "",
  };
}

export default function OrigenEfluentesForm({ ...props }) {
  const { tramite } = useTramite();
  const tramiteForm = useFormikContext();
  const { t } = useTranslation();
  const unidadCaudalMedioCatalog = useCatalog(["unidad", "M3DIA"], () =>
    buscarUnidad("M3DIA"),
  );
  const loading = unidadCaudalMedioCatalog.loading;
  const handleFuentesEfluentesLiquidosChange = (event) => {
    event.preventDefault();
    tramiteForm.handleChange(event);
  };
  return (
    <Loader loading={loading}>
      <ArrayField
        id="fuentesEfluentesLiquidos"
        name="fuentesEfluentesLiquidos"
        label={t("tramite.fuentesEfluentesLiquidos")}
        value={tramiteForm.values.fuentesEfluentesLiquidos}
        onChange={handleFuentesEfluentesLiquidosChange}
        createItem={crearFuenteEfluente}
        isInvalid={isInvalid("fuentesEfluentesLiquidos", tramiteForm)}
        error={
          (tramiteForm.errors.fuentesEfluentesLiquidos instanceof Array &&
            t("errors.tramite.fuentesEfluentesLiquidos.many")) ||
          t(tramiteForm.errors.fuentesEfluentesLiquidos)
        }
        disabled={!isEditable(tramite)}
      >
        {({
          value: fuentesEfluentesLiquidos,
          append,
          remove,
          replace,
          select,
          selectedIndex,
          selectedItem,
          disabled,
        }) => (
          <Grid>
            {!disabled && (
              <Row>
                <Col lg={12}>
                  <FuenteEfluenteLiquidoForm
                    value={selectedItem}
                    page={selectedIndex}
                    pages={fuentesEfluentesLiquidos.length}
                    select={select}
                    append={append}
                    replace={replace}
                    remove={remove}
                    operacionesUnitarias={
                      tramiteForm.values.operacionesUnitarias
                    }
                    unidadCaudalMedio={unidadCaudalMedioCatalog.data}
                    disabled={disabled}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <FuenteEfluenteLiquidoList
                  value={fuentesEfluentesLiquidos}
                  select={select}
                  remove={remove}
                  disabled={disabled}
                />
              </Col>
            </Row>
          </Grid>
        )}
      </ArrayField>
    </Loader>
  );
}
